<template>
        <BasicTile class="feedback-tile__background rounded-16 rounded-md-24" :width="400" :height="300">


		<v-card-title class="text-wrap h-75 text-h6 feedback-tile__review">
			{{ review }}
		</v-card-title>



		<v-card-actions class="mt-6">
			<v-list-item class="w-100">


				<template v-slot:prepend>
					<v-avatar color="grey-darken-3"
						image="https://avataaars.io/?avatarStyle=Transparent&topType=ShortHairShortCurly&accessoriesType=Prescription02&hairColor=Black&facialHairType=Blank&clotheType=Hoodie&clotheColor=White&eyeType=Default&eyebrowType=DefaultNatural&mouthType=Default&skinColor=Light"></v-avatar>
				</template>





				<v-list-item-title class="text-wrap feedback-tile__name">
					{{ name }}
				</v-list-item-title>






				<template v-slot:append>
					<v-icon class="feedback-tile__quote"><quotes-icon></quotes-icon></v-icon>
				</template>


			</v-list-item>
		</v-card-actions>
	</BasicTile>
</template>

<script>

import QuotesIcon from "@/icons/Quotes.vue";
import BasicTile from '@/components/Tiles/Basic-Tile.vue'

export default {
	name: "FeedbackTile",
	components: {
		BasicTile,
		QuotesIcon,
	},
	props: {
		name: {
			type: String,
			required: true
		},
		review: {
			type: String,
			required: true
		}
	},
};
</script>
